export default "__VITE_ASSET__DDDWr0of__"